<h5 class="card-title">Create-a-company</h5>
<div class="flex-container">
    <div class="company-creator-block">
        <div class="custom-form" [formGroup]="companyForm">
            <div style="width: 40%">
                <label class="form-label">Company display name</label>
                <dx-text-box formControlName="name" [as-validator]="customErrors" placeholder="For example ApplicationLink B.V."></dx-text-box>
                <label class="form-label">Type</label>
                <dx-select-box formControlName="creationFlow" [as-validator]="customErrors" [dataSource]="creationFlows" (onValueChanged)="setValidators()"
                    displayExpr="name" valueExpr="id">
                </dx-select-box>
                @if(companyForm.controls.creationFlow.value === CompanyCreationFlow.Standalone) {
                    <label class="form-label">Domain</label>
                    <dx-text-box formControlName="fullIdentifier" [as-validator]="customErrors"
                        placeholder="For example applicationlink.eu">
                    </dx-text-box>
                    <label class="form-label">Registration type</label>
                    <dx-select-box formControlName="companyType" [as-validator]="customErrors" [dataSource]="companyTypes"
                        displayExpr="name" valueExpr="id">
                    </dx-select-box>
                }
                <label class="form-label">Owner E-mail Address (optional)</label>
                <dx-text-box formControlName="initOwnerEmail" [as-validator]="customErrors"></dx-text-box>
                @if(companyForm.controls.creationFlow.value === CompanyCreationFlow.SubCompany) {
                    <label class="form-label">Parent company</label>
                    <dx-select-box formControlName="parentCompanyId" [as-validator]="customErrors" [dataSource]="listOfParentCompanies$ | async"
                        displayExpr="name" valueExpr="id">
                    </dx-select-box>
                }
            </div>
            <br>
        </div>
        <button style="margin-bottom: 5px; margin-right: 5px;" class="btn btn-primary btn-sm" (click)="createCompany()">Create company</button>
        <button style="margin-bottom: 5px;" class="btn btn-primary btn-sm" (click)="errorTest()">Console error test</button>
    </div>
    <div class="company-overview-block">
        <dx-data-grid [dataSource]="listOfCompanies$ | async" [showBorders]="true">
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-paging [enabled]="false"></dxo-paging>

            <dxo-search-panel [visible]="true"></dxo-search-panel>

            <dxi-column dataField="creationDate" caption="Creation date">
            </dxi-column>
            <dxi-column dataField="name" caption="Company name">
            </dxi-column>
            <dxi-column dataField="fullIdentifier" caption="Company identifier">
            </dxi-column>
            <dxi-column dataField="companyType" caption="Company type" cellTemplate="companyTypeTemplate" alignment="left">
            </dxi-column>
            <dxi-column dataField="timezoneString" caption="Company timezone">
            </dxi-column>

            <div *dxTemplate="let data of 'companyTypeTemplate'">
                    {{getCompanyEnumValue(data.data.companyType) }}
            </div>
        </dx-data-grid>

    </div>
</div>
